import { gsap } from 'gsap'

function handleAccordionClick (event) {
    let toggle = event?.target?.closest('[data-accordion-toggle]')
    if (!toggle) {
        const inAccordion = event?.target?.closest('[data-accordion]')
        if (inAccordion) {
            const t = inAccordion.querySelector('[data-accordion-toggle]')
            if (t && inAccordion.contains(event.target)) {
                toggle = t
            }
        }
    }
    if (!toggle) return

    const elParent = toggle.parentElement
    if (!elParent) return

    if (!elParent.contains(event.target)) return

    const elMain = elParent.querySelector('[data-accordion-main]')
    const elButton = toggle.querySelector('button')
    if (!elMain || !elButton) return

    event.preventDefault()
    event.stopImmediatePropagation()

    const wasOpen = elParent.getAttribute('data-open') === 'true'

    if (wasOpen) {
        elParent.setAttribute('data-open', 'false')
        elButton.setAttribute('aria-expanded', 'false')
        elMain.setAttribute('aria-hidden', 'true')
        elMain.setAttribute('inert', '')
        return
    }

    elParent.setAttribute('data-open', 'true')
    elButton.setAttribute('aria-expanded', 'true')
    elMain.setAttribute('aria-hidden', 'false')
    elMain.removeAttribute('inert')
}

function handleAccordionMouseEnter (event) {
    const toggle = event?.target?.closest('[data-accordion-toggle]')
    if (!toggle) return

    const direction = toggle.closest('[data-accordion]')?.getAttribute('data-open') === 'true' ? -1 : 1
    const svg = toggle.querySelector('svg')
    if (!svg) return

    const tl = gsap.timeline({
        defaults: {
            duration: 0.2,
            ease: 'power2.out',
            clearProps: 'all',
        },
    })
    tl.to(svg, { y: 12 * direction })
    tl.to(svg, { y: 0 })
}

document.addEventListener('click', handleAccordionClick, true)
document.addEventListener('mouseenter', handleAccordionMouseEnter, true)
